import { App } from 'vue';
import Tour from './src/tour.vue';

Tour.install = (app: App): void => {
    app.component(Tour.name, Tour);
};

export default Tour;

declare module 'vue' {
    export interface GlobalComponents {
        PtTour: typeof Tour;
    }
}
